// ============================================================================
// Core Game Constants
// ============================================================================
// Game tick rate (ticks per second)
export const TICK_RATE = 20;
export const TICK_INTERVAL_MS = 1000 / TICK_RATE;
// World constants
export const CHUNK_SIZE = 64; // tiles per chunk side
export const TILE_SIZE = 32; // pixels per tile
// ============================================================================
// Network Constants
// ============================================================================
export const MAX_PLAYERS_PER_SERVER = 500;
export const SNAPSHOT_SEND_RATE = 10; // snapshots per second
export const SNAPSHOT_INTERVAL_MS = 1000 / SNAPSHOT_SEND_RATE;
// Add small buffer for network jitter on client
export const CLIENT_SNAPSHOT_BUFFER_MS = 10;
export const CLIENT_SNAPSHOT_INTERVAL_MS = SNAPSHOT_INTERVAL_MS + CLIENT_SNAPSHOT_BUFFER_MS;
export const INPUT_BUFFER_SIZE = 32;
// Note: PROTOCOL_VERSION is in protocol/schemas.ts
// View distance (in chunks)
export const VIEW_DISTANCE_CHUNKS = 3;
// ============================================================================
// Movement Constants
// ============================================================================
// Threshold for considering a pawn to have reached a waypoint (tiles)
export const WAYPOINT_ARRIVAL_THRESHOLD = 0.1;
// Position delta threshold for network sync
export const POSITION_DELTA_THRESHOLD = 0.01;
// Default pawn movement speed (tiles per second)
export const DEFAULT_PAWN_SPEED = 3;
// ============================================================================
// Pathfinding Constants
// ============================================================================
export const DEFAULT_MAX_PATH_ITERATIONS = 5000;
export const PATH_SEARCH_RADIUS = 5; // tiles for finding alternative destinations
// ============================================================================
// Chunk Loading Constants
// ============================================================================
export const MAX_CHUNK_REQUESTS_PER_FRAME = 2;
// Reserved connect name used by client admin viewer mode.
// Server treats this as a read-only spectator connection.
export const ADMIN_VIEWER_PLAYER_NAME = '__ADMIN_VIEWER__';
// ============================================================================
// Combat Constants
// ============================================================================
export const ATTACK_RANGE_MELEE = 1.5; // tiles
export const PICKUP_DURATION_MS = 500; // 0.5 second pickup time
// ============================================================================
// Time Constants
// ============================================================================
// In-game day duration (24 real minutes = 24 in-game hours)
export const GAME_DAY_MS = 24 * 60 * 1000;
// ============================================================================
// Vision Constants (Fog of War)
// ============================================================================
// Vision half-extent per pawn (in tiles) - square area revealed around each owned pawn
export const PAWN_VISION_RADIUS = 60;
// Server uses slightly larger radius to prevent boundary flickering (hysteresis)
export const PAWN_VISION_EXIT_RADIUS = PAWN_VISION_RADIUS + 2;
// ============================================================================
// Construction Constants
// ============================================================================
// Search radius for auto-continuing nearby constructions (in tiles)
export const AUTO_CONTINUE_CONSTRUCTION_RADIUS = 30;
//# sourceMappingURL=constants.js.map